export const useUserSettings = () => {
  const settings = JSON.parse(localStorage.getItem('userSettings'));

  const { lang, notifications, initialPage, theme } = settings;

  return { lang, notifications: !!notifications, initialPage, theme };
};
